(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super()
    }

    handleClick(e) {
      e.preventDefault()
      const {closeAnnouncement} = e.target.dataset
      if (closeAnnouncement === 'row') {
        e.target.closest('.announcement-bar__row').remove()
      } else {
        this.remove()
      }
    }

    connectedCallback() {
      if (this.querySelector('.announcement-bar__close')) {
      this.querySelector('.announcement-bar__close').addEventListener('click', this.handleClick.bind(this))
      }
    }
  }

  customElements.define('announcement-bar', AnnouncementBar)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
class FooterCollapsible extends HTMLElement {
  constructor() {
    super();

    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.summaryIsEmpty = this.summary.textContent.trim().length == 0;
		this.openDefault = this.dataset.openDefault === 'true'

    this.details.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summary.addEventListener('click', this.onSummaryClick.bind(this));
    document.addEventListener('matchMobile', this.close.bind(this));
    document.addEventListener('unmatchMobile', this.open.bind(this));

    if (FoxThemeSettings.isMobile) {
			if (!this.openDefault) this.close()
    }

		document.addEventListener('matchMobile', () => {
			if (!this.openDefault) {
				this.close()
			} else {
				this.open()
			}
		})

		document.addEventListener('unmatchMobile', () => {
			this.open()
		})
		
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open();
  }

  open() {
    this.details.setAttribute('open', true);
  }

  close() {
    !this.summaryIsEmpty && this.details.removeAttribute('open');
  }
}

customElements.define('footer-collapsible', FooterCollapsible);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderMenu extends DetailsDisclosure {
    constructor() {
      super();
      this.header = document.querySelector('.site-header__wrapper');
      this.mainDetailsToggle.addEventListener('toggle', this.onHeaderMenuToggle.bind(this));
    }

    connectedCallback() {
      this.headerInner = document.querySelector('.site-header')
      if( this.headerInner && this.headerInner.classList.contains('show-dropdown-menu-on-hover') ) {
        this.clickTrigger = this.querySelector('summary');
        this.clickTrigger.addEventListener('click', this.disableClickBehavior.bind(this))

        this.dropdownContent = this.querySelector('.f-site-nav__dropdown')

        // Variables to track mouse position.
        this.isMouseOverContainer = false;
        this.isMouseOverContent = false;
        this.delayHover = 200;

        // Show dropdown content on mouse enter.
        this.addEventListener( 'mouseenter', this.onMouseEnterContainer.bind(this) );

        // Hide dropdown content on mouse leave (with a slight delay).
        this.addEventListener( 'mouseleave', this.onMouseLeaveContainer.bind(this) );

        // Check if mouse is over the dropdown content.
        this.dropdownContent.addEventListener( 'mouseenter', this.onMouseEnterDropdownContent.bind(this) );

        // Check if mouse leaves the dropdown content.
        this.dropdownContent.addEventListener('mouseleave', this.onMouseLeaveDropdownContent.bind(this) );
      }
    }

    disconnectedCallback() {
		  this.clickTrigger && this.clickTrigger.removeEventListener( 'click', this.disableClickBehavior.bind(this) )
      this.removeEventListener( 'mouseenter', this.onMouseEnterContainer.bind(this) )
      this.removeEventListener( 'mouseleave', this.onMouseLeaveContainer.bind(this) )
      if( this.dropdownContent ) {
        this.dropdownContent.removeEventListener( 'mouseenter', this.onMouseEnterDropdownContent.bind(this) )
        this.dropdownContent.removeEventListener( 'mouseleave', this.onMouseLeaveDropdownContent.bind(this) )
      }
    }

    disableClickBehavior(evt) {
      evt.preventDefault();
    }

    onMouseEnterContainer() {
      this.isMouseOverContainer = true
      this.closeOtherOnes()
      this.open()
    }

    closeOtherOnes() {
      const headerMenus = this.headerInner.querySelectorAll('header-menu');
      let that = this;
      
      headerMenus && headerMenus.forEach(function (element) {
        if ( element !== that ) {
          element.close()
        }
      });
    }

    onMouseLeaveContainer() {
      let that = this;
      this.isMouseOverContainer = false;
      setTimeout(function () {
        if ( ! that.isMouseOverContent ) {
          that.close();
        }
      }, this.delayHover);
    }

    onMouseEnterDropdownContent() {
      this.isMouseOverContent = true;
    }
    
    onMouseLeaveDropdownContent() {
      let that = this;
      this.isMouseOverContent = false;
      setTimeout(function () {
        if ( ! that.isMouseOverContainer ) {
          that.close();
        }
      }, this.delayHover);
    }

    /**
     * Do not overrided parent function to avoid lost animation effect.
     */
    onHeaderMenuToggle() {
      if (!this.header) return;
      this.header.preventReveal = this.mainDetailsToggle.open;
    }
  }
  customElements.define('header-menu', HeaderMenu);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-sticky-bar"]) return;
  try {
    
  class MobileStickyBar extends HTMLElement {
    constructor() {
      super()
      document.body.classList.add('mobile-sticky-bar-enabled')
    }
  }
  customElements.define('mobile-sticky-bar', MobileStickyBar)


  } catch(e) { console.error(e); }
})();

})();
